import { render, staticRenderFns } from "./ModalCertificacoesExistentes.vue?vue&type=template&id=48981be1&scoped=true"
import script from "./ModalCertificacoesExistentes.vue?vue&type=script&lang=js"
export * from "./ModalCertificacoesExistentes.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificacoesExistentes.vue?vue&type=style&index=0&id=48981be1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48981be1",
  null
  
)

export default component.exports